module.exports = "/_next/static/images/MainPageReviewMiniImg-579e1c9474ca3c4ab9a58eb1180b0dac.png";